module.exports = __webpack_public_path__ + "static/media/400050_01.5a7456ce.png";